'use client';

import { ProblemItem } from '@/features/home/molecules';
import useCheckIsMobileSize from '@/hooks/useCheckIsMobileSize';

const ProblemList = () => {
  const isMobile = useCheckIsMobileSize();
  return (
    <div className="w-full min-w-[327px] md:max-w-[1440px] flex flex-col gap-3">
      <ProblemItem icon="warning" text={isMobile ? `여러 플랫폼에 흩어진 리뷰로<br />관리 사각지대가 생겨요` : `여러 플랫폼에 흩어진 리뷰로 관리 사각지대가 생겨요`} />
      <ProblemItem icon="down" text={isMobile ? `부정 리뷰 대응이 늦어지면,평판과<br />신규 환자 전환율이 떨어져요` : `부정 리뷰 대응이 늦어지면,<br />평판과신규 환자 전환율이 떨어져요`} />
      <ProblemItem icon="cancel" text={isMobile ? `환자가 좋은 진료를 받고도<br />리뷰 작성으로 이어지지 않아요` : `환자가 좋은 진료를 받고도 리뷰 작성으로 이어지지 않아요`} />
    </div>
  );
};

export default ProblemList;
